<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Il ruolo chiave della nostra Academy  è quello di formare e aiutare, adolescenti e non, a realizzare i propri sogni nel mondo del lavoro, ci avvaliamo della Junior Academy, dedicata ai più giovani, con l’intento di favorire la crescita e indirizzare i ragazzi verso il futuro che hanno sempre desiderato.
                    </p>
                    <ul class="social-link">
                        <li><a href="https://m.facebook.com/jroadacademy/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/jroad.academy/?igshid=nptwkwvj0seq" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.jroad.academy/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.jroad.academy/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via Variante 7 Bis, 32<br>80030 Mariglianella (NA) - Italia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390813352659">Telefono: (+39) 081-3352659</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@jroadacademy.com">info@jroadacademy.com</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390813352659">Lunedì-Venerdì: 09:00÷18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2023 J-Road Academy - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2">
                    <ul>
                        <li><a routerLink="/privacy-policy" class="d-none">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
